import { render, staticRenderFns } from "./EditDrink.vue?vue&type=template&id=c458ecd0&scoped=true&"
import script from "./EditDrink.vue?vue&type=script&lang=js&"
export * from "./EditDrink.vue?vue&type=script&lang=js&"
import style0 from "./EditDrink.vue?vue&type=style&index=0&id=c458ecd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c458ecd0",
  null
  
)

export default component.exports